module.exports = __webpack_public_path__ + "img/45.461cebc3.jpg";